// Spinner.tsx
import * as React from 'react';

type SpinnerProps = {
  /** Pixel size of the spinner (defaults to 20px = w-5 h-5) */
  size?: number;
  /** Optional className for color/spacing overrides (uses currentColor) */
  className?: string;
  /** Screen reader label */
  label?: string;
  /** Optional icon to show in the center (e.g., your taskStartedImage) */
  iconSrc?: string;
  /** Stroke width of the ring (in px) */
  strokeWidth?: number;
};

export function Spinner({
  size = 20,
  className = '',
  label = 'Loading',
  iconSrc,
  strokeWidth = 3,
}: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      aria-busy="true"
      className={`relative inline-grid place-items-center align-middle ${className}`}
      style={{ width: size, height: size }}
    >
      {iconSrc ? (
        <img
          src={iconSrc}
          alt=""
          className="pointer-events-none select-none"
          style={{ width: size, height: size }}
        />
      ) : null}

      {/* Rotating ring (inherits currentColor) */}
      <svg
        viewBox="0 0 24 24"
        width={size}
        height={size}
        className="absolute inset-0 animate-spin motion-reduce:animate-none"
        aria-hidden="true"
      >
        {/* Track */}
        <circle
          cx="12"
          cy="12"
          r="10"
          fill="none"
          stroke="currentColor"
          strokeOpacity="0.2"
          strokeWidth={strokeWidth}
        />
        {/* Arc */}
        <path
          fill="currentColor"
          d="M12 2a10 10 0 0 1 10 10h-4a6 6 0 0 0-6-6V2z"
        />
      </svg>

      {/* SR-only text for ATs */}
      <span className="sr-only">{label}</span>
    </span>
  );
}
